import React, { useState, useEffect, useCallback, createContext, useContext } from 'react';
import { Pool } from '@neondatabase/serverless';
import Sidebar from './Sidebar';
import Header from './Header';

// Création du contexte
const LayoutContext = createContext();
export const useLayout = () => useContext(LayoutContext);

const Layout = ({ children }) => {
  const [counts, setCounts] = useState({
    total: 0,
    aTraiter: 0,
    plusTard: 0,
    rendezVous: 0
  });
  const [loading, setLoading] = useState(true);
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const fetchCounts = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch('https://venteclead.st-info.fr/get_counts.php');
      if (!response.ok) {
        throw new Error(`Erreur du serveur: ${response.status}`);
      }
      const data = await response.json();
      if (data.error) {
        throw new Error(data.error);
      }
      setCounts({
        total: data.total || 0,
        aTraiter: data.aTraiter || 0,
        plusTard: data.plusTard || 0,
        rendezVous: data.rendezVous || 0
      });
    } catch (error) {
      console.error("Failed to fetch counts:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCounts();
  }, [fetchCounts]);

  const contextValue = {
    counts,
    loading,
    refetchCounts: fetchCounts,
  };

  return (
    <LayoutContext.Provider value={contextValue}>
      <div className="min-h-screen bg-gray-50">
        <Sidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="lg:ml-64 flex flex-col flex-1">
          <Header setSidebarOpen={setSidebarOpen} />
          <main className="flex-1">
            {children}
          </main>
        </div>
      </div>
    </LayoutContext.Provider>
  );
};

export default Layout;